import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { map } from "lodash";

import { publicRoutePaths } from "@/routes/public.routes.config";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import InquiryCard from "@/modules/frontend/components/Inquiry/InquiryCard";
import { useAuth } from "@/AuthProvider";

import { motion } from "framer-motion";

const InquiryList = ({ mockInquiry }) => {

  const { user } = useAuth();
  
  const InquiryListRef = useRef(null);

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const options = {
    loop: true,
    margin: 24,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    navText: ["<< ", ">>"],
    video: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      767: { items: 2 },
      1000: { items: 3 },
      1280: { items: 3 },
      1440: { items: 3 },
      1441: { items: 4 },
    },
  };

  const goToNext = () => {
    InquiryListRef.current.next();
  };

  const goToPrev = () => {
    InquiryListRef.current.prev();
  };

  return (
    <section className={`frwd-inquiry-wrape`}
    >
      <div className="inner-pad-bg">
        <div className="container">
          <div className="row">
            <div className="col-xxl-2 col-xl-2 col-lg-1 col-md-1"></div>
            <div className="col-xxl-8 col-xl-8 col-lg-10 col-md-10">
              <div className="head-text center">

                <motion.h2 className={`head center animate-child`}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Forwarding Inquiries List</motion.h2>

                <motion.p className={`text animate-child`}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >
                  Access genuine trade inquiries from trusted businesses across the globe. Every lead is an opportunity to expand your network and secure new business deals.
                </motion.p>
              </div>
            </div>

            <motion.div className={`col-md-12 u-relative animate-child`}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >
              <OwlCarousel className="owl-theme" {...options} ref={InquiryListRef}>
                {map(mockInquiry, (item, key) => {
                  return (
                    <div key={`inquiry${key}`}>
                      <InquiryCard data={item} />
                    </div>
                  );
                })}
              </OwlCarousel>
              <div className="nav-ctrl">
                <button type="button" className="btn prev" onClick={goToPrev}>
                  <i className="sprite"></i>
                </button>
                <button type="button" className="btn next" onClick={goToNext}>
                  <i className="sprite"></i>
                </button>
              </div>

              <motion.div className={`btn-wrape center animate-child`}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.3}
                variants={fadeUpVariant}
              >
                {(user == null) && (
                <Link to={publicRoutePaths.VIEW_ALL_INQUIRIES.path} title="View All" className="btn outline"
                  target={"_blank"}
                  rel={"noopener noreferrer"}>
                  View All
                </Link>
                )}
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InquiryList;
